import { Button, Modal, Col } from "react-bootstrap";
import team1 from "../../assets/images/team/team-1-modal.jpg";
import useLang from "hooks/useLang";

const ModalIcon = (props) => {
  const { lang } = useLang();

  return (
    <Modal
      id="modal-detail"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div id="modal-detail-img">
          <Col lg={6} sm={6} className="center">
            <div className="member box-tab">
              <div className="pic owner effect">
                <img src={team1} alt=""/>
              </div>
              <h4>Icon</h4>
              <span>Group CEO & Co-Founder</span>
            </div>
          </Col>
        </div>
        <ul className="inline-item">
          <li className="list-inline-item">
            <i className="uil uil-bell"></i>
            <div>
              <p className="text-muted">
                Registered Tax Consultant Level C (International) from the
                Ministry of Finance of the Republic of Indonesia.
              </p>
            </div>
          </li>
          <li className="list-inline-item">
            <i className="uil uil-star"></i>
            <div>
              <p className="text-muted">Licensed Tax Attorney for Tax Court.</p>
            </div>
          </li>
          <li className="list-inline-item">
            <i className="uil uil-envelope-minus"></i>
            <div>
              <p className="text-muted">
                Fiscal Administration, University of Indonesia.
              </p>
            </div>
          </li>
          <li className="list-inline-item">
            <i className="uil uil-heart-alt"></i>
            <div>
              <p className="text-muted">
                Secretary of Indonesia Tax Consultant Association (IKPI) Depok
                Period 2024-2029.
              </p>
            </div>
          </li>
        </ul>
        <p style={{ textAlign: "justify" }}>{lang.our_team.card_2_detail}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalIcon;
